import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminGuard({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen grid place-items-center bg-white text-slate-500" data-testid="admin-loading">
                Verifying admin access…
            </div>
        );
    }
    if (!user) return <Navigate to="/" replace />;
    if (!user.is_admin) {
        return (
            <div className="min-h-screen grid place-items-center bg-white px-6" data-testid="admin-denied">
                <div className="max-w-md text-center border-2 border-red-200 bg-red-50/60 rounded-2xl p-8">
                    <div className="text-xs font-bold uppercase tracking-widest text-red-700 mb-2">403 · Admin only</div>
                    <div className="font-heading font-bold text-2xl text-red-900">Not authorised</div>
                    <p className="text-sm text-red-700 mt-2">Your account doesn&apos;t have admin permissions on the Statecraft console.</p>
                    <a href="/dashboard" className="inline-block mt-5 px-4 py-2 rounded-lg bg-red-700 text-white text-sm font-semibold">Back to Dashboard</a>
                </div>
            </div>
        );
    }
    return children;
}
